module.exports = __webpack_public_path__ + "static/media/youtube_full.0647f1db85917431bcd51549d3c3f52c.svg";